import { render, staticRenderFns } from "./TableInfoPersonRisk.vue?vue&type=template&id=ac02d55c"
import script from "./TableInfoPersonRisk.vue?vue&type=script&lang=js"
export * from "./TableInfoPersonRisk.vue?vue&type=script&lang=js"
import style0 from "./TableInfoPersonRisk.vue?vue&type=style&index=0&id=ac02d55c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports